// extracted by mini-css-extract-plugin
export default {"mintButton":"VIPSale_mintButton__1aLai"};